import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const links: { to: string; labelKey: string }[] = [
  { to: '/admin/dashboard', labelKey: 'admin.dashboard' },
  { to: '/admin/music', labelKey: 'admin.music' },
  { to: '/admin/photos', labelKey: 'admin.photos' },
  { to: '/admin/videos', labelKey: 'admin.videos' },
  { to: '/admin/fanwall', labelKey: 'admin.fanwall' },
  { to: '/admin/social', labelKey: 'admin.social' },
  { to: '/admin/merch', labelKey: 'admin.merch' },
  { to: '/admin/settings', labelKey: 'admin.settings' },
];

export default function AdminSidebar() {
  const { t } = useTranslation();
  return (
    <aside className="admin-sidebar">
      <nav>
        {links.map(({ to, labelKey }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `admin-sidebar__link ${isActive ? 'admin-sidebar__link--active' : ''}`
            }
          >
            {t(labelKey)}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
